import Swiper, {
  Navigation, Pagination, Autoplay, EffectFade,
} from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

export default function ReviewSlider() {
  const reviewSwiper = new Swiper('.review-slider .swiper', {
    direction: 'horizontal',
    rewind: true,
    effect: 'fade',
    slidesPerView: 1,
    draggable: true,
    // preloadImages: false,
    fadeEffect: { crossFade: true },
    pagination: {
      el: '.review-slider .swiper-pagination',
      clickable: true,
      renderBullet: (index, className) => `<div class="pagination-dot ${className}"></div>`,
    },
  });

  reviewSwiper.on('slideChange', function () {
    const activeCyrElem = document.querySelector('.circle_link-active');
    if (activeCyrElem) {
      activeCyrElem.classList.remove('circle_link-active');
    }
    const selectedCyr = document.querySelector(`[data-slidenum="${this.activeIndex}"]`);
    console.log('selectedCyr', selectedCyr);
    if (selectedCyr) {
      selectedCyr.classList.add('circle_link-active');
    }
  });

  const orbiaLinks = document.querySelectorAll('.review-block [data-slidenum]');
  if (orbiaLinks) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < orbiaLinks.length; i++) {
      orbiaLinks[i].addEventListener('click', function (e) {
        e.preventDefault();
        reviewSwiper.slideTo(parseInt(this.dataset.slidenum, 10));
        const activeCyr = document.querySelector('.circle_link-active');
        if (activeCyr) {
          activeCyr.classList.remove('circle_link-active');
        }
        this.classList.add('circle_link-active');
      });
    }
  }
}
